import { render, staticRenderFns } from "./PdfWidget.vue?vue&type=template&id=406cd915&scoped=true"
import script from "./PdfWidget.vue?vue&type=script&lang=js"
export * from "./PdfWidget.vue?vue&type=script&lang=js"
import style0 from "./PdfWidget.vue?vue&type=style&index=0&id=406cd915&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406cd915",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('406cd915')) {
      api.createRecord('406cd915', component.options)
    } else {
      api.reload('406cd915', component.options)
    }
    module.hot.accept("./PdfWidget.vue?vue&type=template&id=406cd915&scoped=true", function () {
      api.rerender('406cd915', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/playerWidgets/PdfWidget.vue"
export default component.exports